import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby";
import $ from "jquery";

const Menudata = (props) => {
  useEffect(() => {
    $('.navigation li a').click(function () {
      $(window).scrollTop(0);
    })
    $(".navigation .menu-accordian .submenu-list").each(function (i, el) {
      // Remove white space
      var html = $(el).html().replace(/\s+/, "");
      // Check if element is :empty or length of html is zero
      if ($(el).is(":empty") || html.length === 0) {
        $(el).remove();
      } else {
        $(el).parent().addClass('has-submenu');
      }
    });

    $(".card-header.has-submenu .firstleveltrigger").unbind().on("click", function (e) {
      var checkactive = $(this).parent().attr('class');
      if (checkactive.indexOf('active') !== -1) {
        $(".card-header.has-submenu").removeClass('active');
        $('.submenu-list').stop(true, true).slideUp();
        $('.has-submenu .firstleveltrigger i').removeClass('icon-arrow-up');
        $('.has-submenu .firstleveltrigger i').addClass('icon-arrow-down');
      } else {
        $(".card-header.has-submenu").removeClass('active');
        $('.submenu-list').slideUp();
        $('.has-submenu .firstleveltrigger i').removeClass('icon-arrow-up');
        $('.has-submenu .firstleveltrigger i').addClass('icon-arrow-down');
        $(this).parent().addClass("active");
        $(this).parent().find('.submenu-list').stop(true, true).slideDown();
        $(this).parent().find('.firstleveltrigger i').removeClass('icon-arrow-down');
        $(this).parent().find('.firstleveltrigger i').addClass('icon-arrow-up');
      }
    });
  }, []);

  const data = useStaticQuery(graphql`
    query  {  
      glstrapi {
        allMenus(sort:"Sorting:asc") {
          id
          Label
          Primary_URL
          Secondary_URL
          Show_In_Burger_Menu
          Main_Parent {
            id
            Label
            Primary_URL
            Secondary_URL
          }
          Sub_Parent {
            id
            Label
            Primary_URL
            Secondary_URL            
          }
        }
      }
    }
  `)
  var menu_data = data.glstrapi.allMenus;
  var IfExternal_URL = /^((http|https|ftp):\/\/)/;
  return (
    <React.Fragment>
      <div className="navigation">
        <div className="menu-accordian">
          {menu_data.map((mainmenu, index) => {
            return <>
              {mainmenu.Show_In_Burger_Menu ?
                <li className={"card-header card-header-parent"}>
                  {mainmenu.Secondary_URL == null ?
                    <Link to={`/${mainmenu.Primary_URL}/`} className="firstleveltrigger parent-link">{mainmenu.Show_In_Burger_Menu === true && mainmenu.Label}</Link>
                    :
                    <Link to={mainmenu.Secondary_URL} className="firstleveltrigger parent-link">{mainmenu.Show_In_Burger_Menu === true && mainmenu.Label}</Link>
                  }
                  <div className="firstleveltrigger">
                    {menu_data.map((menuitem, key) => {
                      return <>
                        {menuitem.Main_Parent && menuitem.Sub_Parent === null && menuitem.Main_Parent.Label === mainmenu.Label &&
                          <i className="icon-arrow-down"></i>
                        }
                      </>
                    })}
                  </div>
                  <ul className="submenu-list">
                    {menu_data.map((submenu) => {
                      return <>
                        {submenu.Main_Parent && submenu.Sub_Parent === null && submenu.Main_Parent.Label === mainmenu.Label && submenu.Secondary_URL == null &&
                          <li className="card-header card-header-child secondlevel-menu-item">
                            <Link to={`/${submenu.Main_Parent.Primary_URL}/${submenu.Primary_URL}/`}>{submenu.Label}</Link>
                          </li>
                        }
                        {submenu.Main_Parent && submenu.Sub_Parent === null && submenu.Main_Parent.Label === mainmenu.Label && submenu.Secondary_URL != null &&
                          <li className="card-header card-header-child secondlevel-menu-item">
                            {IfExternal_URL.test(submenu.Secondary_URL) ?
                              <a target="_blank" href={submenu.Secondary_URL}>{submenu.Label}</a>
                              :
                              <Link to={submenu.Secondary_URL}>{submenu.Label}</Link>
                            }
                          </li>
                        }
                      </>
                    })}
                  </ul>

                </li>
                : ""}
            </>
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Menudata;

